// extracted by mini-css-extract-plugin
export default {"nav-link":"styles_nav-link__M+6tg","active":"styles_active__iylPW","nav-tabs":"styles_nav-tabs__D-PaG","nav":"styles_nav__gRjsf"};